import { LifeCycle } from '@tools/LifeCycle';
import type { Controller } from '../Controller.svelte';

export abstract class Modifier {
	public strength = 1;
	public active = true;

	public readonly lifeCycle = new LifeCycle();

	protected controller!: Controller;

	private get modifiers() {
		return this.controller.modifiers || [];
	}
	protected get state() {
		return this.controller.context.state;
	}
	protected get connection() {
		return this.controller.context.connection;
	}
	protected get prop() {
		return this.controller.context.prop;
	}

	protected getModifier<T extends Modifier>(type: new () => T): T | undefined {
		return this.modifiers.find((modifier) => modifier instanceof type && modifier.active) as T;
	}

	/**
	 * Create a connection between the main dot and a new dot
	 * @param type - A fluid connection will have its position set to the main dot each tick. A static connection won't
	 * @returns the references to the new dot and stick
	 **/
	protected createConnection(type: 'fluid' | 'static' = 'fluid') {
		return this.controller.createConnection(type);
	}

	public __build(controllers: Controller) {
		this.controller = controllers;
		this.lifeCycle.load();
	}

	protected takeover() {
		if (!this.controller.isTakeoverTarget(this)) {
			this.controller.takeover(this);
		}
	}
	protected giveback() {
		if (this.controller.isTakeoverTarget(this)) {
			this.controller.giveback();
		}
	}

	public effect(): void {}
	public tick(): void {}
}
